import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-accept-modal',
  templateUrl: './terms-accept-modal.page.html',
  styleUrls: ['./terms-accept-modal.page.scss'],
})
export class TermsAcceptModalPage {
  agreeTerms = false;

  constructor(private modalCtrl: ModalController, private router: Router) {}

  accept() {
    if (!this.agreeTerms) return;
    this.modalCtrl.dismiss({ accepted: true });
  }

  termsOfService() {
    this.router.navigate(['/terms-of-service']);
  }

  privacyPolicy() {
    this.router.navigate(['/privacy-policy']);
  }
}